import React from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Martín L.',
  details: '28 años, Buenos Aires',
  role: 'Emprendedor Digital',
  quote: 'Siempre quise vender online pero me aterraba la cámara. Con este sistema facturé mis primeros $1000 USD sin que nadie sepa quién soy.',
  initials: 'ML'
}, {
  name: 'Camila R.',
  details: '24 años, Córdoba',
  role: 'Estudiante',
  quote: "Necesitaba ingresos extra pero no quería exponer mi vida privada. El 'Influencer Invisible' fue la solución perfecta. Súper fácil de seguir.",
  initials: 'CR'
}, {
  name: 'Facundo D.',
  details: '32 años, Rosario',
  role: 'Freelancer',
  quote: 'Estaba cansado de crear contenido y no ver resultados. El sistema de IA me ahorra horas de trabajo. Es literalmente copiar y pegar con estrategia.',
  initials: 'FD'
}, {
  name: 'Valentina S.',
  details: '26 años, Mendoza',
  role: 'Creadora de Contenido',
  quote: 'Había abandonado 3 cuentas por el estrés de la exposición. Ahora manejo 2 canales automatizados y tengo paz mental. Increíble.',
  initials: 'VS'
}, {
  name: 'Nicolás P.',
  details: '30 años, La Plata',
  role: 'Profesional',
  quote: 'No buscaba ser famoso, solo quería monetizar. Este método va directo al grano: ventas sin vanidad. Lo recomiendo 100%.',
  initials: 'NP'
}];
export function TestimonialsSection() {
  return <div className="space-y-8" data-id="element-263">
      {TESTIMONIALS.map((t, i) => <div key={i} className="bg-[#111640] p-6 rounded-xl shadow-md border border-cyan-900/30" data-id="element-264">
          <div className="flex items-center gap-4 mb-4" data-id="element-265">
            <div className="w-12 h-12 rounded-full bg-cyan-600 flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-266">
              {t.initials}
            </div>
            <div data-id="element-267">
              <h4 className="font-bold text-white" data-id="element-268">{t.name}</h4>
              <p className="text-sm text-gray-400" data-id="element-269">{t.details}</p>
            </div>
          </div>
          <div className="flex text-yellow-400 mb-3" data-id="element-270">
            {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-current" data-id="element-271" />)}
          </div>
          <p className="text-gray-300 italic" data-id="element-272">"{t.quote}"</p>
        </div>)}
    </div>;
}